import { useState, useRef, useEffect, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Icon } from 'uxd-design-system-components';
import PlanningTopicsRowProps from '../../types/components/PlanningTopicsRowProps';
import './PlanningTopicsRow.scss';

const PlanningTopicsRow = forwardRef<HTMLInputElement, PlanningTopicsRowProps>((props, ref) => {
  const { topicTitle, topicStatement, topicTitleId, checked, color, handleCardClick } = props;
  const [height, setHeight] = useState(checked ? undefined : 0);
  const heightRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (checked) {
      setHeight(122);
    } else {
      setHeight(0);
    }
  }, [checked]);

  return (
    <div
      className="planning-topics-row"
      data-testid={`planningTopicsRow-${topicTitleId}`}
    >
      <span
        className="planning-topics-header"
        style={{ backgroundColor: color }}
        data-testid="planningTopicsHeader"
      />
      <div className="planning-topics-title">
        <Checkbox
          checked={checked}
          id={`checkbox-${topicTitleId}`}
          name={`checkbox-${topicTitleId}`}
          label=""
          hideLabel
          onChange={() => handleCardClick(topicTitleId)}
          aria-describedby={`${topicTitle}-statement`}
          ref={ref}
        />
        {topicTitle}
        {checked ? (
          <span
            className="planning-topics-button"
            data-testid="planningTopicsRowCheckedIcon"
          >
            <Icon name="caret-up" />
          </span>
        ) : (
          <span
            className="planning-topics-button"
            data-testid="planningTopicsRowUncheckedIcon"
          >
            <Icon name="caret-down" />
          </span>
        )}
      </div>
      <div
        className="planning-topics-statement-container"
        data-testid="planningTopicsRowStatement"
        style={{ height }}
      >
        <div ref={heightRef} id={`${topicTitle}-statement`}>
          {topicStatement}
        </div>
      </div>
    </div>
  );
});

PlanningTopicsRow.propTypes = {
  topicTitle: PropTypes.string.isRequired,
  topicStatement: PropTypes.string.isRequired,
  topicTitleId: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  color: PropTypes.string.isRequired,
  handleCardClick: PropTypes.func.isRequired,
};

export default PlanningTopicsRow;
